import React from 'react';
import { Typography } from '@material-ui/core/';
import { Skeleton } from '@material-ui/lab';
import { MetricCardBase } from './MetricCard';
import MetricCardError from './MetricCardError';
function UsedLicensesMetricCard(_a) {
    var requestState = _a.requestState;
    var status = requestState.status, error = requestState.error, details = requestState.result;
    var label = React.createElement(Typography, { variant: "body1" }, "Used Licenses");
    if (!!error) {
        var metric = React.createElement(MetricCardError, { onClick: function () { } });
        return React.createElement(MetricCardBase, { metric: metric, label: label });
    }
    else if (status === 'loading') {
        var metric = React.createElement(Skeleton, { variant: "rect" });
        var label_1 = React.createElement(Skeleton, { variant: "rect" });
        return React.createElement(MetricCardBase, { metric: metric, label: label_1 });
    }
    else if (!details) {
        // This should never happen.
        // FIXME: Trigger some kind of system notifaction here.
        var metric = React.createElement(MetricCardError, { onClick: function () { } });
        return React.createElement(MetricCardBase, { metric: metric, label: label });
    }
    else if (!details.licensesInUseCount || !details.paidLicenses) {
        var metric = React.createElement(MetricCardError, { noReload: true, onClick: function () { }, message: "Unable to load used license data" });
        return React.createElement(MetricCardBase, { metric: metric, label: label });
    }
    else {
        var metric = React.createElement(Typography, { variant: "h2" }, details.licensesInUseCount.toLocaleString());
        return (React.createElement(MetricCardBase, { metric: metric, label: label, warningMode: details.licensesInUseCount > details.paidLicenses }));
    }
}
export default UsedLicensesMetricCard;
//# sourceMappingURL=UsedLicensesMetricCard.js.map